<template>
  <button class="menu-item"
          :class="{'is-active':isActive? isActive():null}"
  @click="action"
  :title="title"
  >
    <svg height="20" width="20" class="remix" >
      <use :xlink:href="`${remixiconUrl}#ri-${icon}`"></use>
    </svg>
  </button>
</template>
<script>
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    action: {
      type: Function,
      required: true
    },
    isActive: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      remixiconUrl
    }
  }
}
</script>
<style lang="scss" scoped>

.menu-item{
  background: rgba(0, 0, 0, 0.08)!important;
  border: 1px solid rgba(0, 0, 0, 0.12)!important;
  border-radius: 0.4rem!important;
  color: #424242!important;
  cursor: pointer!important;
  height: 1.75rem!important;
  padding: 0.25rem!important;
  margin-right: 0.25rem!important;
  width: 1.75rem!important;
  transition: background-color 0.15s, border-color 0.15s!important;

  &:hover {
    background: rgba(0, 0, 0, 0.14)!important;
    border-color: rgba(0, 0, 0, 0.2)!important;
  }

  svg {
    fill: currentColor!important;
    height: 100%!important;
    width: 100%!important;
  }
}
.is-active {
  background-color: #3d3c3c!important;
  border-color: #3d3c3c!important;
  color: #fff!important;
}

</style>